import { Validator } from '@vista-digital/validator';
import { MemberRewardListActionButtonMode } from './action-button-mode';
export const defaultMemberRewardListActionButtonConfig = {
    show: false,
    mode: MemberRewardListActionButtonMode.Basic
};
export const memberRewardListActionButtonValidator = Validator.object({
    show: Validator.boolean(),
    mode: Validator.oneOf(Object.values(MemberRewardListActionButtonMode))
});
